import React, { useState, useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { UpdateSubscription } from '../../Service';
import { getSingleSubscription } from '../../Service';

export default function EditSubscription(){

    const navigation = useNavigate();
    const [subscriptionData, setSubscriptionData] = useState([]);
    const [formValues, setFormValues] = useState('');
    const [formErrors, setFormErrors] = useState({});
    const { subscriptionId } = useParams();

    useEffect(() => {
        let params = { 'id': subscriptionId };
        getSingleSubscription(params).then(res => handleSingleResponse(res))
      }, []);

      const handleSingleResponse = (response) => {
        if(response.data.code==400){ //IF Token Expired......
            const errors = {};
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: response.data.message,
            })
          }else if(response.data.code==200){  //IF Request is Success
            setSubscriptionData(response.data.data.subscription.items[0]);
          }
      }  

    const hanldeChange = (e) => {
        const value=e.target.value;
        const field=e.target.name;
        console.log(value);
        setSubscriptionData(prevState => ({
        ...prevState,
        [field]: value }));
    }


		const handleSubmit = (e) => {
            e.preventDefault();
            const errorCount = validate(subscriptionData);
            setFormErrors(errorCount);
            console.log(errorCount.status);
       
 
			if(errorCount.status){

				var bodyFormData = subscriptionData;
                 console.log(bodyFormData);

                 UpdateSubscription(bodyFormData).then(res => handleResponse(res))

            }else{
				window.scrollTo(100, 100);
				return false;
			}
		}


        const handleResponse = (response) => {
            if(response.data.code==400){ //IF Token Expired......
                const errors = {};
                Swal.fire({
                  icon: 'error',
                  title: 'Oops...',
                  text: response.data.message,
                })
                errors.status = false;
                setFormErrors(errors);
              }else if(response.data.code==200){  //IF Request is Success
                const myinfo=[];
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Subscription Updated Successfully!',
                    showConfirmButton: false,
                    timer: 1500
                  })
                navigation("/admin-subscription");
              }
          }

 

		const validate = (values) => {
			const errors = {};
			errors.status = true;

			if(!values.sub_name){
				errors.sub_name = 'Subscription Name is required';
				errors.status = false;
			}

            if(!values.sub_validity){
				errors.sub_validity = 'Subscription Duration is required';
				errors.status = false;
			}

            if(!values.sub_price){
				errors.end_date = 'Subscription Price is required';
				errors.status = false;
			}

			return errors;
		}


        console.log(subscriptionId);

 return(
<section className="admin-section">
<div className="container">
<div className="row">
<div className="col-md-12 col-12">
<div className="admin-edit">
<h1>UPDATE SUBSCRIPTION DETAILS</h1>
<Form onSubmit={handleSubmit} className="event-form">
    <Form.Group>
        <Form.Label>Name <span className='star'>*</span></Form.Label>
        <Form.Control type="text" name="sub_name" value={subscriptionData.sub_name} placeholder="Subscription Name" onChange={hanldeChange} />
        <p className="error">{formErrors.sub_name}</p>
    </Form.Group>
<Row>
    <Col>
    <Form.Group>
        <Form.Label>Duration<span className='star'>*</span></Form.Label>
        <Form.Select aria-label="Default select example" name="sub_validity" onChange={hanldeChange} >
        <option value="">-- Choose Duration --</option>
        <option value="1" selected={subscriptionData.sub_validity==1 ? "selected" : ""}>Annually</option>
        <option value="2" selected={subscriptionData.sub_validity==2 ? "selected" : ""}>Half-Yearly</option>
        <option value="3" selected={subscriptionData.sub_validity==3 ? "selected" : ""}>Quarterly</option>
        <option value="4" selected={subscriptionData.sub_validity==4 ? "selected" : ""}>Monthly</option>
        </Form.Select>
        <p className="error">{formErrors.sub_validity}</p>
    </Form.Group>
    </Col>
    <Col>
    <Form.Group controlId="enddate">
        <Form.Label>Price in USD<span className='star'>*</span></Form.Label>
        <Form.Control type="text" name="sub_price" value={subscriptionData.sub_price} placeholder="Subscription Price" onChange={hanldeChange} />
        <p className="error">{formErrors.end_date}</p>
    </Form.Group>
    </Col>
</Row>

<hr/>

    <Button variant="primary" type="submit" className='submit' onClick={handleSubmit} >
        Update
    </Button>
</Form>
</div>
</div>
</div>
</div>
</section>
)
}